import { useContext } from 'react';
import LastWakeContext from './LastWakeContext';

function useLastWake() {
  return useContext(LastWakeContext);
}

export default useLastWake;
